<template>
    <div>
        <trial-end-clock
            :title="$t.__('pages.errors.ErrorCartExpired.offer_not_exist')"
            :subtitles="[$t.__('pages.errors.ErrorCartExpired.offer_disappeared')]"
        >
            <a
                href="javascript:;"
                onclick="MySupport.getForm();"
                class="primary-50-bkg white br fs-4 lh-24 pt-2 pb-2 pl-4 pr-4 semibold"
            >
                {{ $l10n.__('Contacter un commercial') }}
            </a>
            <div class="fs-4 lh-24 semibold mt-4" v-html="tchat"></div>
        </trial-end-clock>
    </div>
</template>

<script>
import TrialEndClock from 'vcomponents/pages/errors/TrialEndClock.vue';

export default {
    components: {
        TrialEndClock,
    },
    computed: {
        tchat: function () {
            return this.$l10n.__('Ou revenir sur %(startTag)s sellsy.com %(endTag)s', {
                startTag: '<a href="/home" class="link fs-4 lh-24 semibold">',
                endTag: '</a>',
            });
        },
    },
};
</script>
